import { CustomCallbackErrorAxiosInstance } from '@/types';
import { interceptErrorHTTP } from '@/utils/helper';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

const interceptSuccess: (response: AxiosResponse) => AxiosResponse = response =>
  response;

const interceptError = (
  useCustomCallback?: CustomCallbackErrorAxiosInstance<AxiosError>
) => (error: AxiosError) => {
  return interceptErrorHTTP(error, useCustomCallback);
};

interface AxiosInstanceParams {
  version?: '/v1' | '/v2';
  customCallbackError?: CustomCallbackErrorAxiosInstance<AxiosError>;
  customRequestConfig?: AxiosRequestConfig;
  customRequestConfigHeaders?: AxiosRequestConfig['headers'];
}

function createAxiosInstance({
  version = '/v1',
  customCallbackError = {},
  customRequestConfig = {},
  customRequestConfigHeaders = {},
}: AxiosInstanceParams = {}) {
  const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}${version}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'x-api-key': process.env.REACT_APP_API_KEY,
      ...customRequestConfigHeaders,
    },
    timeout: 15000,
    ...customRequestConfig,
  });

  const token = localStorage.getItem('token');
  if (token) {
    axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
  }

  axiosInstance.interceptors.response.use(
    interceptSuccess,
    interceptError(customCallbackError)
  );

  return axiosInstance;
}

export default createAxiosInstance;
